import { InjectionToken } from '@angular/core';

export const LOCATION_TOKEN = new InjectionToken<Location>('Window location object', {
  factory: (): Location => window.location,
  providedIn: 'root'
});
